import React, { Component } from "react";
import { DurableFunctionInstance} from "../../models/DurableFunctionInstance";
import DurableFunctionInstanceStatus from "../DurableFunctionInstanceStatus";

interface AutomationDurableFunctionInstanceStatusProps {
    durableFunctionInstance?: DurableFunctionInstance
    flex?: string;
}

interface AutomationDurableFunctionInstanceStatusState {

}

export default class AutomationDurableFunctionInstanceStatus extends Component<AutomationDurableFunctionInstanceStatusProps, AutomationDurableFunctionInstanceStatusState> {

    public render() {
        
        let pillColourOverride: string | undefined = undefined;
        let runtimeStatusTextOverride: string | undefined = undefined;
        if(this.props.durableFunctionInstance?.runtimeStatus === "Completed")
        {
            pillColourOverride = "amber";
            runtimeStatusTextOverride = "Stopped";
        }
        if(this.props.durableFunctionInstance?.runtimeStatus === "Running")
        {
            pillColourOverride = "green";
        }
        
        return (
            <DurableFunctionInstanceStatus
                durableFunctionInstance={this.props.durableFunctionInstance}
                flex={this.props.flex}
                pillColourOverride={pillColourOverride}
                runtimeStatusTextOverride={runtimeStatusTextOverride}
            />
        );
    }
}